<template>
  <InvoiceParameterDefaultModal
    title="Confirmar alteração da Regra"
    width="660"
    showOctagon
    disableBodyPadding
    :show="show"
    @close="confirm(false)">
    <template slot="icon">
    </template>
    <template slot="body">
      <div>
        <div style="padding: 20px 20px 0;">
          <TextBase>
            Você está prestes a alterar os detalhes da seguinte regra.
          </TextBase>
          <TextBase>
            Por favor, revise as informações antes de confirmar:
          </TextBase>
        </div>
        <v-divider class="my-4"/>
      </div>
      <v-data-table
        hide-default-footer
        class="invoice-parameter-table"
        mobile-breakpoint="0"
        :headers="headers"
        :items="formsToValidate">
        <template
          v-slot:[`header.field`]>
          <Header>Campo</Header>
        </template>
        <template
          v-slot:[`header.previous`]>
          <Header>Regra Anterior</Header>
        </template>
        <template
          v-slot:[`header.new`]>
          <Header>Nova Regra</Header>
        </template>
        <template
          v-slot:[`item.field`]="{item}">
          <TableBody textBold>{{item.field}}</TableBody>
        </template>
        <template
          v-slot:[`item.previous`]="{item}">
          <TableBody v-if="item.field === 'Tipo de Nível'">
            {{getEntityLevelName(item.previous)}}
          </TableBody>
          <TableBody v-if="item.field === 'Opção de Nível'">
            {{item.previous}}
          </TableBody>
          <TableBody v-if="item.field === 'Regra'">
            {{item.previous}}
          </TableBody>
          <TableBody v-if="item.field === 'Descrição'">
            {{item.previous}}
          </TableBody>
          <div v-if="item.field === 'Valor'">
            <TableBody
              v-if="!isList(item.currentForm.config.valueType)">
              {{ convertText(getConfigValue(item.previous, item.currentForm.config.valueType)) }}
            </TableBody>
            <div
              class="d-flex flex-row align-center"
              v-if="isList(item.currentForm.config.valueType)">
              <v-chip>
                <TableBody textSm>
                  {{ convertText(getConfigValue(item.previous[0], item.currentForm.config.valueType)) }}
                </TableBody>
              </v-chip>
              <v-tooltip
                bottom>
                <template v-slot:activator="{ on: onTab, attrs: attrsTab }">
                  <span
                    v-on="onTab"
                    v-bind="attrsTab"
                    textSm
                    class="ml-2 foreground--text text-caption">
                    {{
                      formatter.getPluralText(
                        "outra",
                        item.previous
                      )
                    }}
                  </span>
                </template>
                <span>
                  {{ getOptionsDescription(item.previous, item.currentForm.config.valueType) }}
                </span>
              </v-tooltip>
            </div>
          </div>
          <TableBody v-if="item.field === 'Status'">
            {{item.previous ? 'Ativo' : 'Inativo'}}
          </TableBody>
        </template>
        <template
          v-slot:[`item.new`]="{item}">
          <TableBody v-if="item.field === 'Tipo de Nível'">
            {{getEntityLevelName(item.new)}}
          </TableBody>
          <TableBody v-if="item.field === 'Opção de Nível'">
            {{item.new}}
          </TableBody>
          <TableBody v-if="item.field === 'Regra'">
            {{item.new}}
          </TableBody>
          <TableBody v-if="item.field === 'Descrição'">
            {{item.new}}
          </TableBody>
          <div v-if="item.field === 'Valor'">
            <TableBody
              v-if="!isList(item.currentForm.config.valueType)">
              {{ convertText(getConfigValue(item.new, item.currentForm.config.valueType)) }}
            </TableBody>
            <div
              class="d-flex flex-row align-center"
              v-if="isList(item.currentForm.config.valueType)">
              <v-chip>
                <TableBody textSm>
                  {{ convertText(getConfigValue(item.new[0], item.currentForm.config.valueType)) }}
                </TableBody>
              </v-chip>
              <v-tooltip
                bottom>
                <template v-slot:activator="{ on: onTab, attrs: attrsTab }">
                  <span
                    v-on="onTab"
                    v-bind="attrsTab"
                    textSm
                    class="ml-2 foreground--text text-caption">
                    {{
                      formatter.getPluralText(
                        "outra",
                        item.new
                      )
                    }}
                  </span>
                </template>
                <span>
                  {{ getOptionsDescription(item.new, item.currentForm.config.valueType) }}
                </span>
              </v-tooltip>
            </div>
          </div>
          <TableBody v-if="item.field === 'Status'">
            {{item.new ? 'Ativo' : 'Inativo'}}
          </TableBody>
        </template>
      </v-data-table>
      <p
        class="text-center font-weight-bold foreground--text ui-text-base">
        Deseja realmente confirmar essa alteração?
      </p>
    </template>
    <template slot="actions">
      <div
        class="d-flex justify-end gap-h-20 fill-width">
        <v-btn
          class="action-button-modal"
          color="primary"
          outlined
          @click="confirm(false)">
          Cancelar
        </v-btn>
        <v-btn
          class="action-button-modal"
          color="primary"
          @click="confirm(true)">
          Continuar Alteração
        </v-btn>
      </div>
    </template>
  </InvoiceParameterDefaultModal>
</template>
<script>
import InvoiceParameterDefaultModal from './InvoiceParameterDefaultModal.vue';
import InvoiceParameterTableBody from '../components/InvoiceParameterTableBody.vue';
import InvoiceParameterHeader from '../components/InvoiceParameterHeader.vue';
import InvoiceParameterText from '../components/InvoiceParameterText.vue';
import { mapGetters, mapMutations, mapState } from 'vuex';
import InvoiceParametersMixin from '@/shared/mixins/invoiceParameters/InvoiceParametersMixin';
export default {
  name: "ConfirmAlterationRuleModal",
  components: {
    TableBody: InvoiceParameterTableBody,
    Header: InvoiceParameterHeader,
    TextBase: InvoiceParameterText,
    InvoiceParameterDefaultModal,
  },
  mixins: [
    InvoiceParametersMixin
  ],
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    }
  },
  methods: {
    ...mapMutations({
      setShowConfirmAlterationRuleModal: 'invoice-parameter/setShowConfirmAlterationRuleModal',
      resolvePromise: 'invoice-parameter/resolvePromise',
    }),
    confirm(confirmation) {
      this.$emit('confirm', confirmation);
      this.resolvePromise(confirmation);
      this.setShowConfirmAlterationRuleModal(false);
    }
  },
  computed: {
    ...mapGetters({
      formsToValidate: 'invoice-parameter/formsToValidate',
    }),
    headers() {
      return [
        { value: 'field', sortable: false, class: 'col-type', cellClass: 'col-type' },
        { value: 'previous', sortable: false, class: 'col-entity', cellClass: 'col-entity' },
        { value: 'new', sortable: false, class: 'col-entity', cellClass: 'col-entity' },
      ];
    },
  }
}
</script>
<style lang="scss">
@import "@/shared/styles/invoiceParameters/default.scss";
@import "@/shared/styles/invoiceParameters/table.scss";
</style>